import React from "react";
import { ArrowRightIcon } from "lucide-react";
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary";
  full?: boolean;
};
export function CtaButton({
  href,
  children,
  variant = "primary",
  full = false
}: CtaButtonProps) {
  const styles = variant === "primary" ? "bg-coral text-white hover:bg-[#B9452F] shadow-[0_6px_0_0_#9C3824] active:translate-y-[3px] active:shadow-[0_3px_0_0_#9C3824]" : "bg-chalk text-white hover:bg-chalk-dark";
  return <a href={href} className={`${full ? "w-full" : ""} inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-4 text-center text-sm sm:text-base font-extrabold tracking-wide transition-[background-color,transform,box-shadow] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-pencil ${styles}`} data-id="element-79" data-mp="lkfrf6r9kmay">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-80" data-mp="159q0w30f2b0m" />
    </a>;
}